import {Injectable, Type} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";

@Injectable({
    providedIn: 'root'
})
export class EaColumnService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ea/eaColumns')
    }

    getObjectComponent(): Type<any> {
        return null;
    }

    confirmHeader(id: number, confirmedName: string, alias?: string): Observable<any> {
        const params: any = {confirmedName};
        if (alias) {
            params.alias = alias;
        }
        return this.http.post(`${this.apiUrl}/confirmHeader/${id}`, {}, {params});
    }
}
